module.exports = __webpack_public_path__ + "static/media/Robots.1e262ed2.txt";


//////////////////
// WEBPACK FOOTER
// ./public/Robots.txt
// module id = 1525
// module chunks = 1